/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import { SkillCardPlaceholder } from 'bundles/enterprise-legacy-learner-home/components/myLearning/skillsDashboard/SkillCard';
import { useHeaderLevel } from 'bundles/page-config-common/contexts/HeaderLevelContext';

const styles = {
  header: css`
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--cds-spacing-100);
  `,
  skills: css`
    margin: var(--cds-spacing-150) 0;
    display: flex;
    flex-wrap: wrap;
    gap: var(--cds-spacing-300) var(--cds-spacing-400);

    // Targets individual skill cards / placeholders
    > div {
      flex: 1 1 33%;
      max-width: 31%;
      ${breakpoints.down('md')} {
        max-width: 100%;
      }
    }
  `,
};

type Props = {
  loading: boolean;
  title?: string;
  subtitle?: string;
  cta?: React.ReactElement | null;
  skillCards?: React.ReactElement[];
};

export const SkillsFocusModule = ({ loading, title, subtitle, cta, skillCards }: Props) => {
  const { currentLevel } = useHeaderLevel();

  if (!loading && skillCards && !skillCards?.length) {
    return null;
  }

  return (
    <PageGridContainer data-testid="enterprise-skills-module">
      <Grid item xs={12}>
        <Grid container css={styles.header}>
          <Typography variant="h1semibold" component={currentLevel}>
            {title}
          </Typography>
          {cta}
        </Grid>
        <Typography2 component="span">{subtitle}</Typography2>
        {/* Display placeholders while loading */}
        <Grid css={styles.skills}>{loading ? [0, 1, 2].map((i) => <SkillCardPlaceholder key={i} />) : skillCards}</Grid>
      </Grid>
    </PageGridContainer>
  );
};

export default SkillsFocusModule;
